import React, { useEffect, useState } from "react";
import { Effect } from "../../types/effects";
import dreamWorldProvider from "../../DreamWorldProvider";
import { motion } from "framer-motion";
import AllMostUsedEffectsModal from "../modals/AllMostUsedEffectsModal";
import { useSelector } from "react-redux";
import { selectUserGlobalData } from "../../store/dreamworldSlice";
import LoadingIndicator from "../ui/LoadingIndicator";
import Section from "../ui/Section";

interface MostUsedEffectsProps {
  onEffectClick: (effect: Effect) => void;
}

const MostUsedEffects: React.FC<MostUsedEffectsProps> = ({
  onEffectClick,
}) => {
  const [effects, setEffects] = useState<Effect[]>([]);
  const [loading, setLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const userGlobalData = useSelector(selectUserGlobalData);

  useEffect(() => {
    if (userGlobalData?.user?.uid) {
      setLoading(true);
      dreamWorldProvider
        .getMostUsedEffects(userGlobalData.user.uid)
        .then(({ effects }) => {
          setEffects(effects);
        })
        .finally(() => setLoading(false));
    }
  }, [userGlobalData]);

  return (
    <>
      <Section
        title="Most Used Effects"
        onSeeAll={() => setIsModalOpen(true)}
      >
        <div className="relative">
          {loading ? (
            <div className="flex justify-center items-center h-48">
              <LoadingIndicator />
            </div>
          ) : (
            <div className="flex space-x-4 overflow-x-auto p-4">
              {effects.map((effect) => (
                <motion.div
                  key={effect.id}
                  className="flex-shrink-0 w-64 bg-gray-800 rounded-lg shadow-lg cursor-pointer"
                  whileHover={{ scale: 1.05 }}
                  onClick={() => onEffectClick(effect)}
                >
                  <img
                    src={effect.image}
                    alt={effect.title}
                    className="w-full h-32 object-cover rounded-t-lg"
                  />
                  <div className="p-4">
                    <h3 className="text-white font-semibold">{effect.title}</h3>
                    <p className="text-gray-400 text-sm line-clamp-3">
                      {effect.description}
                    </p>
                    <p className="text-purple-400 text-xs mt-2">
                      Used {effect.useCount} times
                    </p>
                  </div>
                </motion.div>
              ))}
            </div>
          )}
        </div>
      </Section>
      {isModalOpen && (
        <AllMostUsedEffectsModal onClose={() => setIsModalOpen(false)} />
      )}
    </>
  );
};

export default MostUsedEffects;
